import { computed, inject, type MaybeRefOrGetter, provide, toValue } from 'vue';
import {
  type InsightPrefillStatusesContext,
  InsightPrefillStatusesContextKey,
} from '@/components/home/insights/injectionKeys';
import type { InsightRecommendedActionPromptPrefillStatus } from '@/types/insights';

export const createInsightPrefillStatuses = (
  statuses: MaybeRefOrGetter<InsightRecommendedActionPromptPrefillStatus[]>,
): InsightPrefillStatusesContext => {
  const statusMap = computed(
    () =>
      new Map(
        toValue(statuses).map(status => [
          status.uuid,
          status.prefill_prompt_generation_status,
        ]),
      ),
  );

  return {
    resolveStatus: uuid => statusMap.value.get(uuid),
  };
};

export const provideInsightPrefillStatuses = (
  statuses: MaybeRefOrGetter<InsightRecommendedActionPromptPrefillStatus[]>,
) => {
  provide(
    InsightPrefillStatusesContextKey,
    createInsightPrefillStatuses(statuses),
  );
};

export const useInsightPrefillStatuses = (): InsightPrefillStatusesContext => {
  return inject(InsightPrefillStatusesContextKey, {
    resolveStatus: () => undefined,
  });
};
